import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, Subject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { api } from '@shared/api/api.contract';
import { buildUrl } from '@shared/api/build-url';
import { Project, InsertProject } from '../dto';


@Injectable({
  providedIn: "root",
})
export class ProjectsService {
  /** React Query invalidateQueries karşılığı */
  private refresh$ = new Subject<void>();

  constructor(private http: HttpClient) { }

  // Listeleme
  public getProjects(): Observable<Project[]> {
    return this.http.get<any[]>(api.projects.list.path, { withCredentials: true })
      .pipe(
        map(projects => projects.map(p => ({
          ...p,
          imageUrl: p.image_url,
          githubUrl: p.github_url,
          demoUrl: p.demo_url,
          videoUrl: p.video_url,
          isFeatured: p.is_featured
        }))),
        catchError(() => throwError(() => new Error('Failed to fetch projects')))
      );
  }

  public getProjectSlugs(): Observable<string[]> {
    return this.http.get<any[]>(api.projects.list.path, { withCredentials: true })
      .pipe(
        map(projects => projects.map(p => p.slug)),
        catchError(() => throwError(() => new Error('Failed to fetch project slugs')))
      );
  }


  // Slug ile Dosyadan/Bellekten bulma
  public getProjectFromFile(slug: string): Observable<Project | null> {
    if (!slug) return of(null);
    return this.getProjects().pipe(
      map(items => items.find(i => i.slug === slug) ?? null)
    );
  }

  /** POST /projects */
  createProject(data: InsertProject): Observable<Project> {
    const validated = api.projects.create.input.parse(data);

    return this.http.post<Project>(api.projects.create.path, validated, {
      withCredentials: true,
    })
      .pipe(
        tap(() => this.refresh$.next()), // invalidate
        catchError((err) => {
          if (err.status === 400) {
            throw new Error(err.error?.message ?? 'Validation error');
          }
          throw new Error('Failed to create project');
        })
      );
  }

  /** invalidateQueries eşdeğeri */
  onRefresh(): Observable<void> {
    return this.refresh$.asObservable();
  }
}
